<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
export default {
  components: {},
  data() {
    return {
    };
  },

  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/interview/index.vue